export default "__VITE_ASSET__ChweZMHj__"